import { useState } from 'react';
import { Drawer, Grid } from 'antd';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { DashboardProps } from './types';
import { APPLICATION_NAME } from 'configs';

const { useBreakpoint } = Grid;
const sidebarWidth = 240;

const DashboardLayout = ({ children }: DashboardProps) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const { lg: isDesktop } = useBreakpoint();

  return (
    <div className="flex h-screen overflow-hidden">
      {isDesktop ? (
        <aside
          className="shadow-lg h-screen bg-white transition-all duration-200"
          style={{ width: collapsed ? 70 : sidebarWidth }}
        >
          <div className="flex flex-col h-full">
            <div className="flex items-baseline px-4 py-6 gap-1">
              {!collapsed && <span className="text-black font-semibold text-md select-none whitespace-nowrap">{APPLICATION_NAME}</span>}
              {collapsed && <span className="text-black font-semibold text-md select-none">UM</span>}
            </div>
            <Sidebar collapsed={collapsed} />
          </div>
        </aside>
      ) : (
        <Drawer placement="left" closable onClose={() => setCollapsed(false)} open={collapsed} width={sidebarWidth}>
          <Sidebar collapsed={false} onClose={() => setCollapsed(false)} />
        </Drawer>
      )}

      <div className="flex flex-col w-full h-full">
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        <div className="h-full overflow-y-auto p-4 bg-[#f8f8f8]">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
